// Copyright (c) 2016 Deere & Company

import ProductViews from '../../product/shared/components/product-views';

export default {
    component: ProductViews,
    name: 'PRODUCT_TRACKING',
    path: 'products'
};



// WEBPACK FOOTER //
// ./src/routes/products/products.js